// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { DataProvider } from './pages/Cache';
import { UserProvider, useUser } from './UserContext';
import ProtectedRoute from './ProtectedRoute';
import api from './api/api';

// FRONTEND PAGES
import Home from './pages/Home';
import CityHome from './pages/CityHome';
import Home2 from './pages/Home2';
import PlayerList from './pages/Player_List';
import Rules from './pages/Rules';
import PlayerListDouble from './pages/PlayerListDouble';
import News from './pages/News';
import Results from './pages/Results';
import Matches from './pages/MatchPage';
import Players from './pages/Player';
import Teams from './pages/Team';
import Login from './pages/Login';
import Skorboard from './pages/Skorboard';
import Communication from './pages/Communication';
import Transfers from './pages/Transfers';
import Penalties from './pages/Penalties';
import Rewards from './pages/Rewards';
import TeamList from './pages/TeamList';
import AllTeamList from './pages/AllTeamList';
import LeagueStandings from './pages/LeagueStandings';
import Fixture from './pages/Fixture';
import AllResults from './pages/AllResults';
import AllResultsMobile from './pages/AllResultsMobile';

// EDITOR PAGES
import Editor from './editor_pages/Editor';
import EditorMenu from './editor_pages/EditorMenu';
import EditorPlayers from './editor_pages/Editor_Players';
import EditorTeams from './editor_pages/Editor_Teams';
import EditorMatches from './editor_pages/Editor_Matches';
import EditorLeagues from './editor_pages/Editor_Leagues';
import EditorSeasons from './editor_pages/Editor_Seasons';
import AddMatch from './editor_pages/Add_Match';
import EnterStats from './editor_pages/Enter_Stats';
import UpdateMatch from './editor_pages/Update_Match';
import UpdateTeam from './editor_pages/Update_Team';
import UpdatePlayer from './editor_pages/Update_Player';
import Add_Writings from './editor_pages/Add_Writings';
import AddUser from './editor_pages/Add_User';

function AppRoutes() {
  const location = useLocation();
  const { user, setUser } = useUser();
  const [isLoading, setIsLoading] = useState(true);

  // Oturum doğrulaması: önce cache'den, yoksa API'den
  useEffect(() => {
    const verify = async () => {
      try {
        const cached = localStorage.getItem('user');
        if (cached) {
          setUser(JSON.parse(cached));
          return;
        }
        const res = await api.get('/users/verify');
        setUser(res.data.user);
        localStorage.setItem('user', JSON.stringify(res.data.user));
      } catch {
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };
    verify();
  }, [location, setUser]);

  if (isLoading) return <div>Loading...</div>;

  // Editor menüsünü gösterilecek yollar
  const editorPaths = [
    '/editor','/editor/oyuncular','/editor/takimlar','/editor/maclar',
    '/editor/ligler','/editor/sezonlar','/editor/mac-ekle','/editor/yazi-ekle',
    '/editor/takim-guncelle','/editor/oyuncu-guncelle','/editor/kullanici-ekle'
  ];
  const showEditor = editorPaths.some(p => location.pathname.startsWith(p));

  return (
    <div className="app-container">
      {showEditor && <EditorMenu />}
      <div className="content">
        <Routes>
          {/* SEZONA GÖRE */}
          <Route path="/:cityName/:leagueName/:seasonName" element={<Home />} />
          

          {/* Şehir Anasayfası */}
          <Route path="/:cityName" element={<CityHome />} />

          {/* Genel Anasayfa */}
          <Route path="/" element={<Home2 />} />

          {/* Statik Sayfalar */}
          <Route path="/oyuncu-listesi" element={<PlayerList />} />
          <Route path="/kurallar" element={<Rules />} />
          <Route path="/haberler" element={<News />} />
          <Route path="/giris" element={<Login />} />
          <Route path="/skorboard" element={<Skorboard />} />
          <Route path="/takim-listesi" element={<AllTeamList />} />
          <Route path="/haberler-ve-duyurular" element={<News />} />
          <Route path="/iletisim" element={<Communication />} />

          {/* SEZON İÇİ ALT SAYFALAR */}
          <Route path='/:cityName/:leagueName/:seasonName/puan-durumu' element={<LeagueStandings />} />
          <Route path='/:cityName/:leagueName/:seasonName/fikstur' element={<Fixture />} />
          <Route path='/:cityName/:leagueName/:seasonName/sonuclar' element={<AllResults />} />
          <Route path='/:cityName/:leagueName/:seasonName/sonuclar-mobil' element={<AllResultsMobile />} />
          <Route path='/:cityName/oyuncular/:playerID' element={<Players />} />
          <Route path='/:cityName/takimlar/:teamName' element={<Teams />} />
          <Route path='/:cityName/:leagueName/:seasonName/maclar/:matchID' element={<Matches />} />
          <Route path='/:cityName/:leagueName/:seasonName/transferler' element={<Transfers />} />
          <Route path='/:cityName/:leagueName/:seasonName/cezalar' element={<Penalties />} />
          <Route path='/:cityName/:leagueName/:seasonName/en-degerliler-gol-kralligi' element={<PlayerListDouble />} />
          <Route path='/:cityName/:leagueName/:seasonName/odul-kosesi' element={<Rewards />} />

          {/* LİG/SEZON ÖZEL */}
          <Route path='/:leagueName/:seasonName/sonuclar' element={<Results />} />
          

          {/* EDITOR (Korunmuş) */}
          <Route path="/editor" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <Editor />
            </ProtectedRoute>
          }/>
          {/* ...diğer editor sayfaları aynı pattern ile */}
          <Route path="/editor/oyuncular" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <EditorPlayers />
            </ProtectedRoute>
          }/>
          <Route path="/editor/takimlar" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <EditorTeams />
            </ProtectedRoute>
          }/>
          <Route path="/editor/maclar" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <EditorMatches />
            </ProtectedRoute>
          }/>
          <Route path="/editor/ligler" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <EditorLeagues />
            </ProtectedRoute>
          }/>
          <Route path="/editor/sezonlar" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <EditorSeasons />
            </ProtectedRoute>
          }/>
          <Route path="/editor/mac-ekle" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <AddMatch />
            </ProtectedRoute>
          }/>
          <Route path="/editor/mac-guncelle/:matchId" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <UpdateMatch />
            </ProtectedRoute>
          }/>
          <Route path="/editor/ist-gir/:matchId" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <EnterStats />
            </ProtectedRoute>
          }/>
          <Route path="/editor/takim-guncelle" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <UpdateTeam />
            </ProtectedRoute>
          }/>
          <Route path="/editor/oyuncu-guncelle/:matchId" element={
            <ProtectedRoute user={user} roleRequired={['editor','admin']}>
              <UpdatePlayer />
            </ProtectedRoute>
          }/>
          <Route path="/editor/yazi-ekle" element={
            <ProtectedRoute user={user} roleRequired={['admin','editor']}>
              <Add_Writings />
            </ProtectedRoute>
          }/>
          <Route path="/editor/kullanici-ekle" element={
            <ProtectedRoute user={user} roleRequired={['admin']}>
              <AddUser />
            </ProtectedRoute>
          }/>
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <DataProvider>
      <UserProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </UserProvider>
    </DataProvider>
  );
}

export default App;
